import { render, staticRenderFns } from "./HospitalListFor800.vue?vue&type=template&id=58255b44&scoped=true&"
import script from "./HospitalListFor800.vue?vue&type=script&lang=js&"
export * from "./HospitalListFor800.vue?vue&type=script&lang=js&"
import style0 from "./HospitalListFor800.vue?vue&type=style&index=0&id=58255b44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58255b44",
  null
  
)

export default component.exports